import React, { useState } from 'react';
import { FileText } from 'lucide-react';
import NotaPromissoria from '../../pages/contratos/NotaPromissoria';

const NotaPromissoriaButton = ({ lote, organizador, dropdown = false }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <button
        onClick={() => setShowModal(true)}
        className={dropdown
          ? "w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center gap-2 whitespace-nowrap"
          : "flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors text-sm font-medium"
        }
        title="Nota Promissória"
      >
        <FileText size={16} />
        Nota Promissória
      </button>

      {showModal && (
        <NotaPromissoria
          lote={lote}
          organizador={organizador}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default NotaPromissoriaButton;
